<template>
    <div>
        <nav-bar></nav-bar>
        <div class="container">
          <div class="card card-404">
            <div class="card-content">
              <h1 class="h1-404 has-text-centered">
                ¡Oops!
              </h1>
              <p class="title has-text-centered">
                No podemos encontrar la página a la que quieres acceder.<br><br>
                Revisa la dirección introducida o ve a alguna de las secciones disponibles en el menú
              </p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>

export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue